import React, { useState, useRef } from 'react';
import AempUserIcon from '../../../icons/aemp-user-icon';
import { useSignUpFormContext } from '../../cadastro-context';
import Button from '../../../commons/component/button';
import { createCustomer, hasPatternError } from '../../cadastro-services';
import CompanyFormStepsComponent from './company-form-steps-component';
import config from '../../../generated/config';

const CadastroEmpresa = ({ history }) => {
  const { updateState, ...cadastroState } = useSignUpFormContext();
  const { companyFormStatus } = cadastroState;
  const [captcha, setCaptcha] = useState();
  const { errors } = cadastroState;

  const cnpjRef = useRef();
  const corporateNameRef = useRef();
  const fantasyNameRef = useRef();
  const emailRef = useRef();
  const zipCodeRef = useRef();
  const stateRef = useRef();
  const cityRef = useRef();
  const addressRef = useRef();
  const numberRef = useRef();
  const neighborhoodRef = useRef();
  const stateRegistryRef = useRef();
  const phoneRef = useRef();
  const contactNameRef = useRef();

  const companyRefs = {
    cnpjRef,
    corporateNameRef,
    fantasyNameRef,
    emailRef,
    zipCodeRef,
    stateRef,
    cityRef,
    addressRef,
    numberRef,
    neighborhoodRef,
    stateRegistryRef,
    phoneRef,
    contactNameRef
  };

  const inputRefMap = {
    cnpj: cnpjRef,
    corporateName: corporateNameRef,
    fantasyName: fantasyNameRef,
    email: emailRef,
    zipCode: zipCodeRef,
    state: stateRef,
    city: cityRef,
    address: addressRef,
    number: numberRef,
    neighborhood: neighborhoodRef,
    stateRegistry: stateRegistryRef,
    phone: phoneRef,
    contactName: contactNameRef
  };

  return (
    <div className="cadastroForm-container">
      <h2 className="cadastroForm-title">
        <AempUserIcon />
        <span>{config.signUpScreen.company.formTitle}</span>
      </h2>
      <div className="cadastroComprador">
        <div className="compradorHeader">
          <p className="compradorSubtitle">{config.signUpScreen.company.formSubtitle}</p>
        </div>

        <form
          className="cadastroForm"
          onSubmit={async event => {
            event.preventDefault();
            if (hasPatternError(errors)) {
              const errorArray = Object.keys(errors);
              const error = errorArray[0];
              if (inputRefMap[error]) {
                inputRefMap[error].current.focus();
                return;
              }
            }
            await createCustomer(cadastroState, updateState, captcha, history.push);
          }}
        >
          <CompanyFormStepsComponent
            cadastroState={cadastroState}
            setCaptcha={setCaptcha}
            updateState={updateState}
            {...companyRefs}
          />

          <div className="cadastro-buttons">
            <Button
              primary
              disabled={cadastroState.isFormSubmitting || companyFormStatus !== 'THIRD_STEP'}
              loading={cadastroState.isFormSubmitting}
              className="cadastroForm-submit"
            >
              {config.signUpScreen.company.buttonSubmit}
            </Button>
            <button
              className="btn button-ghost"
              disabled={cadastroState.isFormSubmitting}
              onClick={() => history.push('/cadastro/comprador')}
            >
              {config.signUpScreen.company.goBack}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CadastroEmpresa;
